<mat-button-toggle-group class="without-checked-state">
  <mat-button-toggle
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    class="toolbar-button without-checked-state"
    [matTooltip]="tooltipText"
  >
    <ng-content select="[projection-location='button']"></ng-content>
  </mat-button-toggle>
</mat-button-toggle-group>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isPopoverOpen$ | async"
>
  <div h3ScrollDisabler class="popover-with-header mat-elevation-z4">
    <div class="popover-title">{{ popoverTitle }}</div>
    <div class="popover-body">
      <ng-content select="[projection-location='popover-content']"></ng-content>
    </div>
  </div>
</ng-template>
